import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LEGAL_PATHS, resolveSeo } from '@/lib/seoConfig';
import {
  buildOrganizationSchema,
  buildWebPageSchema,
  buildWebSiteSchema,
  type SchemaNode,
} from '@/lib/schema';

const SCHEMA_ATTR = 'data-route-schema';

function clearRouteSchema(): void {
  document.querySelectorAll(`script[${SCHEMA_ATTR}]`).forEach((node) => node.remove());
}

function injectSchema(nodes: SchemaNode[]): void {
  nodes.forEach((node) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute(SCHEMA_ATTR, '');
    script.textContent = JSON.stringify(node);
    document.head.appendChild(script);
  });
}

// Injecte les données structurées Schema.org propres à chaque route.
// Volontairement séparé du gestionnaire de balises Open Graph / Twitter (RouteSeo)
// pour ne pas mélanger l'injection JSON-LD et la mutation des balises méta.
export default function RouteSchema() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace(/\/+$/, '') || '/';
    clearRouteSchema();

    if (path === '/') {
      injectSchema([buildOrganizationSchema(), buildWebSiteSchema()]);
    } else if (LEGAL_PATHS.includes(path)) {
      const seo = resolveSeo(path);
      injectSchema([buildWebPageSchema(seo.title, seo.description, path)]);
    }
    // Les pages de résultats gèrent leur propre BreadcrumbList (composant Breadcrumbs),
    // et les fiches praticiens injectent un balisage Physician à partir des données chargées.

    return () => clearRouteSchema();
  }, [location.pathname]);

  return null;
}